import { Link } from 'react-router-dom';
import { credentials, stats } from '@/mocks/firm';

export default function AttorneyIntro() {
  return (
    <section className="px-4 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        <div className="w-full lg:w-[440px] h-[520px] rounded-lg overflow-hidden relative flex-shrink-0">
          <img
            src="https://storage.helloreaddy.io/project_files/6d2969aa-ff4c-44b4-abbc-659d70a9ecbd/83744547-e0c3-4f8e-a916-77f69bbe7c14_compressed_mi-retrato.webp"
            alt="Máster León Felipe Ramos Santos, abogado en Heredia, Costa Rica"
            title="Máster León Felipe Ramos Santos, abogado en Heredia"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex-1">
          <p className="text-secondary-500 text-xs uppercase tracking-[0.25em] mb-3 font-semibold">conozca a su abogado</p>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">León Felipe Ramos Santos</h2>
          <div className="text-foreground-700 text-sm md:text-base leading-relaxed mt-5 space-y-4 text-left md:text-justify hyphens-none">
            <p>Sabemos que detrás de cada situación legal hay una persona, una familia, una preocupación o una decisión importante.</p>
            <p>Por eso, nuestra asesoría legal no se limita a explicar leyes o procedimientos. <strong>Escuchamos, orientamos y acompañamos a cada persona durante el proceso</strong>, procurando que comprenda sus opciones y pueda tomar decisiones con seguridad y tranquilidad.</p>
            <p>Ofrecemos una atención cercana y personalizada, con el rigor jurídico que cada caso requiere, pero también con algo que consideramos esencial: <strong>humanidad</strong>.</p>
            <p>Porque recibir asesoría legal también significa sentirse escuchado, comprendido y acompañado.</p>
            <p><strong>Nuestro compromiso es estar a su lado, defender sus derechos y ayudarle a encontrar el camino jurídico más adecuado para su situación.</strong></p>
          </div>
          {credentials.length > 0 && (
            <ul className="mt-6 space-y-3">
              {credentials.map((c) => (
                <li key={c} className="flex items-start gap-3 text-sm text-foreground-800">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5"><i className="ri-check-double-line"></i></span>{c}
                </li>
              ))}
            </ul>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
            {stats.map((s, i) => (
              <div key={s.label} className={`rounded-lg p-4 ${i === 2 ? 'bg-accent-100' : 'bg-background-100'}`}>
                <p className={`font-heading text-3xl font-semibold ${i === 2 ? 'text-accent-800' : 'text-primary-500'}`}>{s.value}</p>
                <p className="text-xs text-foreground-600 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
          <Link to="/about#trayectoria" className="inline-flex items-center gap-2 mt-8 text-sm font-semibold text-primary-500 hover:text-primary-700 cursor-pointer whitespace-nowrap">
            Trayectoria <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}